import HeroHomeBlock from './views/HeroHomeBlock';
export default HeroHomeBlock;
